module.exports = __webpack_public_path__ + "files/c1bba22ec1012961b09623cb57c7d434.svg";